import { Constants } from "../../data/constants";
import { HttpService } from "../../utils/HttpService";

export class UserService {
  constructor() {
    this.constants = new Constants();
    this.HttpService = new HttpService();
  }
  getAllUsersService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getUsers,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  viewAllUsersByAccountId = async (session_id, accountId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.accountServicesURLs.getAccounts + `users/${accountId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  validateUserNumber = async (session_id, userNumber) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.validateUserNumber + `userNumber/${userNumber}`,
        session_id
      );
    } catch (e) {
      return null
    }
  };
  getAllUsersByAccountIdService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getUsers + `byAccountId`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getUsersByType = async (session_id, userType) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getUsers +
          `byAccountId/userType/${userType}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAllUsersByAccountIdServiceAndStateACT = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getUsers + `byAccountId`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getUsersByAccountIdAndGroupIdService = async (session_id, groupId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getUsers +
          `byAccountId` +
          `/groupId/${groupId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getUserByIdService = async (session_id, userId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getUsers + `userId/${userId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  createUser = async (
    session_id,
    user,
    apiUrl = this.constants.userServicesURLs.postUser
  ) => {
    try {
      return await this.HttpService.postJson(
        apiUrl,
        {
          accountId: user.accountId,
          userId: user.userId,
          userBirthdate: user.userBirthdate,
          userEmail: user.userEmail,
          userFullname: user.userFullname,
          userGender: user.userGender,
          userName: user.userName,
          userNumber: user.userNumber,
          userPassword: user.userPassword,
          userType: user.userType,
          billingId: user.billingId,
          cfg: user.cfg,
          createAdminFlag: user.createAdminFlag,
          sxgId: user.sxgId
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteUser = async (session_id, userId, userType) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.userServicesURLs.getUsers +
          `byAccountId` +
          `/userId/${userId}` +
          `/userType/${userType}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  deleteUserFromGroup = async (session_id, groupId, userId) => {
    try {
      return await this.HttpService.deleteJson(
        this.constants.userServicesURLs.getUsers +
          `byAccountId` +
          `/groupId/${groupId}` +
          `/userId/${userId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  editUser = async (session_id, user) => {
    try {
      return await this.HttpService.putJson(
        this.constants.userServicesURLs.editUser,
        {
          accountId: user.accountId,
          groupId: user.groupId,
          userId: user.userId,
          userStatus: user.userStatus,
          userBirthdate: user.userBirthdate,
          userEmail: user.userEmail,
          userFullname: user.userFullname,
          userGender: user.userGender,
          userName: user.userName,
          userNumber: user.userNumber,
          userPassword: user.userPassword,
          userType: user.userType,
          cfg: user.cfg,
          changeStatusFrom: user.agentCurrentStatus,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  updateProfile = async (session_id, user) => {
    try {
      return await this.HttpService.putJson(
        this.constants.userServicesURLs.updateProfile,
        {
          accountId: user.accountId,
          groupId: user.groupId,
          userId: user.userId,
          userStatus: user.userStatus,
          userBirthdate: user.userBirthdate,
          userEmail: user.userEmail,
          userFullname: user.userFullname,
          userGender: user.userGender,
          userName: user.userName,
          userNumber: user.userNumber,
          userPassword: user.userPassword,
          userType: user.userType,
          language: user.language,
          cfg: user.cfg,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getUserByIdService = async (session_id, userId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.editUser + `/userId/${userId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  getUserByTypeService = async (session_id, userType) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getUserByType + `${userType}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  assignUserGroup = async (session_id, groupId, userId) => {
    try {
      return await this.HttpService.postJson(
        this.constants.userServicesURLs.assignUser + "/group",
        {
          userId: userId,
          groupId: groupId,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  changePassword = async (session_id, userPassword) => {
    try {
      return await this.HttpService.putJson(
        this.constants.userServicesURLs.changePassword,
        {
          currentPassword: userPassword.currentPassword,
          newPassword: userPassword.newPassword,
          confirmPassword: userPassword.confirmPassword,
          userEmail: userPassword.userEmail,
        },
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  // resetPassword = async (session_id, userId) => {
  //   try {
  //     return await this.HttpService.putJson(
  //       this.constants.userServicesURLs.resetPassword + `/userId/${userId}`,
  //       {},
  //       session_id
  //     );
  //   } catch (e) {
  //     throw e;
  //   }
  // };
  resetPassword = async (session_id, data) => {
    try {
      return await this.HttpService.putJson(
        this.constants.userServicesURLs.resetPassword + `/userId`,
        data,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };
  resetPasswordForForget = async (session_id, data) => {
    try {
      return await this.HttpService.putJson(
        this.constants.userServicesURLs.resetPasswordForForget,
        data,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAllAgentStatusService = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getAllAgentStatus,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  changeAgentStatus = async (
    session_id,
    record,
    apiUrl = this.constants.userServicesURLs.changeAgentState
  ) => {
    try {
      return await this.HttpService.postJson(apiUrl, record, session_id);
    } catch (e) {
      throw e;
    }
  };

  getUserGroup = async (session_id, userId) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getUserGroup +
          `byAccountId/userId/${userId}`,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  getAllUsersGroups = async (session_id) => {
    try {
      return await this.HttpService.getJson(
        this.constants.userServicesURLs.getUsersGroups,
        session_id
      );
    } catch (e) {
      throw e;
    }
  };

  // getAggregatedContractProfiles = async (identifierNumber) => {
  //   try {
  //     const apiUrl =
  //       this.constants.serverTibcoMNP +
  //       `ODS/IVR/GetAggregatedContractProfiles?IdentifierNumber=${identifierNumber}&IdentifierType=1&RetrieveAggregatedUsageFlag=&RetrieveGrantedUsageFlag=`;

  //     const response = await axios.get(apiUrl, {
  //       headers: {
  //         "Content-Type": "application/xml",
  //       },
  //     });
  //     const xmlData = response.data;

  //     const jsonData = xmljs.xml2js(xmlData, { compact: true, spaces: 4 });

  //     const errorCode =
  //       jsonData.GetAggregatedContractProfileResponse.Header.Exception
  //         .ExceptionCode._text;
  //     const priceGroupType =
  //       jsonData.GetAggregatedContractProfileResponse.ResponseBody
  //         .ContractProfile.PriceGroupType._text;

  //     console.log("ErrorCode:", errorCode);
  //     console.log("PriceGroupType:", priceGroupType);
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };
}
